import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Image } from 'ui';
import styles from './WelcomeHighlights.module.css';

export default function WelcomeHighlights() {
    return (
        <Container className={styles.container}>
            <Row className={styles.row}>
                <Col xs={1} className={styles.iconCol}>
                    <Image name="Lock.svg" />
                </Col>
                <Col xs={11} className={styles.text}>
                    We use machine learning, computer vision and AI for a forensic identity
                    authentication.
                </Col>
            </Row>
            <Row className={styles.row}>
                <Col xs={1} className={styles.iconCol}>
                    <Image name="Shield.svg" />
                </Col>
                <Col xs={11} className={styles.text}>
                    Your information will only be used by{' '}
                    <a
                        href="https://authenticating.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.link}
                    >
                        Authenticating.com
                    </a>{' '}
                    for verification purposes.
                </Col>
            </Row>
            <Row className={styles.row}>
                <Col xs={1} className={styles.iconCol}>
                    <Image name="Clock.svg" />
                </Col>
                <Col xs={11} className={styles.text}>
                    This process takes only a couple of minutes.
                </Col>
            </Row>
        </Container>
    );
}
